module.exports = __webpack_public_path__ + "static/img/banner02.e38e231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner02.jpg
// module id = GGMj
// module chunks = 1